<div id="{{ id_dialog }}"
     class="ui modal tiny neon-border arka-plan"
     [class.boyutlu]="!!ayarlar?.boyut?.w"
     [style.width]="ayarlar?.boyut?.w ? (ayarlar.boyut.w + 'px') : 'fit-content'"
     style="overflow-y: hidden;background-color: transparent; text-shadow: 0 0 10px rgb(0 255 255 / 95%);color: white;pointer-events: all;position:fixed;">

     <div style="display: flex;align-items: center;position: absolute;top:0;left:0;right:0;padding: 4px 8px;z-index:1000;color: white;"
          class="baslikMove">
          <img [src]="ayarlar?.simgeResim || './simgeler/plan.webp'"
               style="width: 22px !important;height: 22px;object-fit: contain;margin-right:6px;">

          {{ayarlar?.baslik ?? "FikoYT Diyalog" }}

          <a class="ui circular icon label"
             (click)="kapa()"
             style="position: absolute;right:0.3rem;top:0.3rem;background-color:transparent;box-shadow: 0px 0px 12px rgb(255 255 255 / 50%);margin:0;">
               <i class="icon close"
                  style="color:white;"></i>
          </a>
     </div>

     <div class="scrolling content"
          style="color: black;background-color: transparent;padding: 1px 5px;pointer-events: all;height: -webkit-fill-available;max-height: unset;">
          <!-- *ngIf ile component her açılışta yeniden oluşturulur,
               böylece pencere setter'ı her seferinde çağrılır ve subscription düzgün kurulur -->
          <div *ngIf="bilesen && miAcik"
               style="display: flex;align-items: center;justify-content: center;margin-top:4px;min-height: 100px;">
               <ng-container *ngComponentOutlet="bilesen; inputs:bilesenParametreler" />
          </div>
     </div>

</div>